import { ColDef, GridApi } from "ag-grid-community";
import { TABLE_HEADER_CLASS, TABLE_MONEY_CELL_STYLE } from "components/layout/table/tableStandard";

export const RIVET_BUDGET_GRID_CLASS = "rivet-budget-grid";

export const RIVET_BUDGET_GRID_WRAPPER_CLASS =
  "min-w-0 rounded-xl border border-border bg-muted/40 overflow-hidden mb-8 h-full";

export const RIVET_BUDGET_TOP_SHEET_WRAPPER_CLASS =
  "flex h-full min-h-0 min-w-0 flex-col overflow-hidden rounded-xl border border-border bg-muted/40";

export const RIVET_BUDGET_TOP_SHEET_GRID_CLASS = "min-h-0 flex-1";

export const RIVET_BUDGET_TOP_SHEET_GRID_MARKER_CLASS = "rivet-budget-top-sheet-grid";

export const RIVET_BUDGET_GRID_HEIGHT_CLASS = "h-full min-h-[320px]";

export const BUDGET_PANEL_CARD_CLASS = "card-border rounded-xl overflow-hidden";

/** Neutral inset surface for budget panel detail/assumption rows (matches grid card tone). */
export const BUDGET_PANEL_SURFACE_CLASS =
  "overflow-hidden rounded-lg border border-border bg-muted/40";

export const baseHeaderClasses = TABLE_HEADER_CLASS;

export const AccountNumberMaxWidth = 132;
export const AccountDescriptionMaxWidth = 1000;

export const defaultColDef: ColDef = {
  autoHeight: true,
  enableCellChangeFlash: false,
  headerClass: baseHeaderClasses,
  suppressMovable: true,
  cellStyle: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    overflow: "hidden",
  },
  sortable: false,
};

export const topSheetDefaultColDef: ColDef = {
  ...defaultColDef,
  autoHeight: false,
};

export const budgetMonetaryCellStyle = TABLE_MONEY_CELL_STYLE;

export { getVarianceToneClass } from "./budgetGridFormatting";

export const budgetGridLinkClass =
  "cursor-pointer font-medium text-primary underline decoration-primary/30 decoration-1 underline-offset-[3px] transition-colors hover:text-primary/80 hover:decoration-primary/70 focus-visible:outline-none focus-visible:text-primary/80";

export const budgetGridCellSelectClass =
  "h-full w-full cursor-pointer border-0 bg-transparent px-3 text-sm capitalize text-foreground outline-none focus:ring-0 appearance-none";

export function isActiveGridApi(api: GridApi | null | undefined): api is GridApi {
  return !!api && !(typeof api.isDestroyed === "function" && api.isDestroyed());
}
